<template>
  <div v-if="isReady" class="floating-ai-container">
    <Transition name="floating-ai-slide">
      <div
        v-if="isOpen"
        class="floating-ai-drawer"
        :class="{ 'is-expanded': isExpanded }">
        <GlobalAIChat
          @close="closeChat"
          @expand="expandChat"
          :isExpanded="isExpanded" />
      </div>
    </Transition>

    <button
      v-if="showButton && !isOpen"
      class="floating-ai-button"
      @click="toggleChat">
      <StarIcon size="24" color="#FFFFFF" opacity="1" />
    </button>

    <Transition name="floating-ai-fade">
      <div v-if="isOpen" class="floating-ai-backdrop" @click="closeChat"></div>
    </Transition>
  </div>
</template>

<script>
import StarIcon from "../icons/StarIcon.vue";
import GlobalAIChat from "./GlobalAIChat.vue";
import { useMainStore } from "../../stores/main";

export default {
  name: "FloatingAIButton",
  components: { StarIcon, GlobalAIChat },
  props: { showButton: { type: Boolean, default: false } },
  data() {
    return { isExpanded: false };
  },
  computed: {
    isReady() {
      return !!useMainStore().userData;
    },
    isOpen() {
      return useMainStore().aiChatOpen;
    },
  },
  mounted() {
    useMainStore()
      .ensureUserData()
      .catch(() => {});
  },
  methods: {
    toggleChat() {
      useMainStore().toggleAiChat();
    },
    closeChat() {
      useMainStore().closeAiChat();
      this.isExpanded = false;
    },
    expandChat() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
